// ========================================
// These are exported only for use in other routes and tests!
// see the exported components and custom hooks for navigation!
// ========================================
const activeTabParamName = "activeTab";
export const basePath = "workspaces/";
export const idParamName = "id";
export const idPath = `:${idParamName}/`;
export const overviewPath = "overview/";
export const productsPath = "products/";
export const purchaseOrderGeneralRoute = `/${basePath}${idPath}:${activeTabParamName}`;
export const purchaseOrderOverviewRoute = `/${basePath}${idPath}${overviewPath}`;
export const purchaseOrderProductsRoute = `/${basePath}${idPath}${productsPath}`;
